import { createElement } from "react";
import toast from "react-hot-toast";
import {
  CheckCircle2,
  CircleAlert,
  Copy,
  Info,
  LoaderCircle,
  TriangleAlert,
} from "lucide-react";

const iconClass = "text-current";

function repeatableOptions(kind, message, options) {
  // Updating a visible error avoids stacking the same repeated failure.
  return typeof message === "string" ? { id: `${kind}:${message}`, ...options } : options;
}

function withIcon(Icon, options = {}) {
  const icon = options.icon || createElement(Icon, {
    size: 20,
    width: 20,
    height: 20,
    strokeWidth: 2,
    className: iconClass,
    "aria-hidden": true,
  });
  return {
    ...options,
    icon: createElement("span", { className: "knowmapped-toast-icon", "aria-hidden": true }, icon),
  };
}

export function showSuccessToast(message, options = {}) {
  return toast.success(message, withIcon(CheckCircle2, { duration: 2800, ...options }));
}

export function showErrorToast(message, options = {}) {
  return toast.error(message, withIcon(CircleAlert, { duration: 6000, ...repeatableOptions("error", message, options), ariaProps: { role: "alert", "aria-live": "assertive", ...options.ariaProps } }));
}

export function showWarningToast(message, options = {}) {
  return toast(message, withIcon(TriangleAlert, { duration: 4500, ...repeatableOptions("warning", message, options) }));
}

export function showInfoToast(message, options = {}) {
  return toast(message, withIcon(Info, { duration: 3200, ...options }));
}

export function showClipboardToast(message, options = {}) {
  return toast(message, withIcon(Copy, { duration: 2400, ...options }));
}

export function showLoadingToast(message, options = {}) {
  return toast.loading(message, withIcon(LoaderCircle, {
    duration: Infinity,
    ...options,
    icon: createElement(LoaderCircle, { size: 20, width: 20, height: 20, strokeWidth: 2, className: "animate-spin text-current", "aria-hidden": true }),
  }));
}

export function clearToasts() { toast.remove(); }

export function dismissToast(id) {
  if (id) toast.dismiss(id);
}

// Compatibility facade for screens that still use toast.success/error while
// migrating to the shared presentation helpers.
export const appToast = {
  success: showSuccessToast,
  error: showErrorToast,
  loading: showLoadingToast,
  info: showInfoToast,
  warning: showWarningToast,
};
